export const InputLabels = {
  Phone: 'Phone',
  Address: 'Address',
  Unit: 'Unit',
  Province: 'Province',
  City: 'City',
  PostalCode: 'Postal code',
  BuildingClass: 'Property types',
  Beds: 'Numbers of Bedrooms',
  HalfBaths: 'Number of Half Bathrooms',
  FullBaths: 'Number of Full Bathrooms',
  Sqft: 'Interior Sqft',
  Timespan: 'Timespan',
  FirstName: 'First Name',
  LastName: 'Last Name',
  Day: 'Day',
  Email: 'Email',
  EmailAddress: 'Email Address',
  Name: 'Name',
};

export const InputEventTypes = {
  Change: 'change',
  Click: 'click',
  Blur: 'blur',
  ErrorChange: 'error-change',
  UpdateValidation: 'update-validation',
};

export const InputRegex = {
  Phone: /\D/g,
  PostalCode: /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
  AddressStartsWithSpaces: /^\s*$/,
  Price: /^\s*-?[1-9]{1,10}\s*$/,
  Email: /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,4}$/,
};

export const InputLengths = {
  Name: 255,
  Email: 255,
};
